@if (showEmailSentDialog$ | async) {
  <dcr-dialog
    open
    headline="E-mail verzonden"
    icon="portal:mail"
    type="confirm"
    (confirm)="onEmailSentDialogConfirm()"
    data-cy="request-sent-message"
  >
    <div>Check je inbox: er is een e-mail gestuurd naar het opgegeven e-mailadres om je wachtwoord opnieuw in te stellen.</div>
  </dcr-dialog>
}

<router-outlet></router-outlet>
<div *ngIf="showQrScanner" class="[ block p-k-s p-bs-2xl ]">
  <div
    class="[ block min-h-3xs corner-m relative ] [ tablet-l:corner-left-xl tablet-l:corner-right-none tablet-l:max-h-full tablet-l:absolute ] [ bottom-0 index-overlay left-0 right-1/2 top-0 overflow-hidden ]"
  >
    <campus-camera
      [showOverlay]="true"
      [isScannerEnabled]="true"
      [showCameraSelect]="true"
      (scanResultReceived)="onScanResultReceived($event)"
      data-cy="qr-scanner"
    ></campus-camera>
    <div
      *ngIf="scanError"
      class="[ absolute index-overlay text-warn warn-container bottom-0 left-0 right-0 center-content ]"
      data-cy="qr-scanner-error"
    >
      {{ scanError }}
    </div>
  </div>
</div>

<ng-container *ngIf="role$ | async as role">
  <kabas-login-form
    [role]="role"
    (formSubmitted)="login($event)"
    (schoolCode)="schoolCodeSet($event)"
    (toggleQrScanner)="toggleQrScanner($event)"
    [qrScanner]="showQrScanner$ | async"
    (resetPasswordEvent)="resetPassword($event)"
    [success]="loginSucceeded$ | async"
    [error]="(route.queryParams | async)?.err"
  ></kabas-login-form>
</ng-container>
